module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b395342091ad731257aeee0d6d03d19a.png";